import Vue from 'vue';
import dayjs from 'dayjs';
require('dayjs/locale/ru')

dayjs.locale('ru')

Vue.prototype.$dayjs = dayjs;

export default dayjs
